import { LOCATION_CITY } from '../../routes';
import customAxios from "../../customAxios";
import {locationNamespace} from "../../../types/location.namespace";

async function updateCity(_id: string, props: locationNamespace.city.update) {
  try {
    return (await customAxios.patch(`${LOCATION_CITY}/${_id}`, props)).data;
  } catch (error: any) {
    console.error({LOCATION_CITY: error});
  }
}

export default updateCity;
